import { gql } from 'apollo-angular';

export var add_blocked_committee_date = gql`
  mutation addBlockedCommitteeDate($date: Date) {
    addBlockedCommitteeDate(date: $date) {
      id
      date
    }
  }
`;
